import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import { normalizePathname } from "../utils/pathname";

const navItems = [
  { name: "Home", path: "/" },
  { name: "Gallery", path: "/gallery" },
  { name: "Videos", path: "/videos" },
  { name: "Guides", path: "/blog" },
  { name: "Pricing", path: "/pricing" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const pathname = normalizePathname(location.pathname);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);
  useEffect(() => {
    if (!menuOpen) return;
    const closeOutside = (event) => {
      if (!menuRef.current?.contains(event.target)) setMenuOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
        buttonRef.current?.focus();
      }
    };
    document.addEventListener("mousedown", closeOutside);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("mousedown", closeOutside);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [menuOpen]);
  return (
    <header className="site-header">
      <Link reloadDocument={/^\/blog\/[^/]+\/?$/.test(location.pathname)} to="/" className="site-brand">Nature Touch</Link>
      <div id="mixer-header-controls" className="header-playback-slot" />
      <nav aria-label="Main navigation" className="header-navigation" ref={menuRef}>
        <Link reloadDocument={/^\/blog\/[^/]+\/?$/.test(location.pathname)} to="/pricing" className="upgrade-link">Upgrade</Link>
        <button ref={buttonRef} type="button" className="header-icon-button" aria-label={menuOpen ? "Close navigation" : "Open navigation"} aria-expanded={menuOpen} aria-controls="header-menu" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes aria-hidden="true" /> : <FaBars aria-hidden="true" />}
        </button>
        {menuOpen && (
          <div id="header-menu" className="header-menu">
            {navItems.map((item) => <Link reloadDocument={/^\/blog\/[^/]+\/?$/.test(location.pathname)} key={item.path} to={item.path} aria-current={pathname === item.path ? "page" : undefined}>{item.name}</Link>)}
          </div>
        )}
      </nav>
    </header>
  );
}
